import { Breadcrumbs, Container } from '@/components';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import Arrow from './assets/curved-arrow.svg';
import styles from './styles.module.scss';
import { ROUTES } from '@/libs/routing';

export const HeadSection: FC = () => {
  const { t } = useTranslation('common');

  return (
    <Box component="section" className={styles.section}>
      <Breadcrumbs float items={[{ label: t('footer.nav.about'), url: ROUTES.ABOUT }]} />
      <Container>
        <Box className={styles.body}>
          <Typography variant="h1" className={styles.title}>
            <Trans ns="about" i18nKey="head.title" components={{ s: <span /> }} />
          </Typography>
          <Typography variant="subtitle2" className={styles.subtitle}>
            <Trans ns="about" i18nKey="head.subtitle" />
          </Typography>
          <Box className={styles.baseIndicator}>
            <Box component="span" className={styles.baseIndicatorText}>
              <Trans ns="about" i18nKey="head.baseText" />
            </Box>
            <Box className={styles.baseIndicatorIcon}>
              <Arrow />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
